export type ChatMessage = {
    id: string;
    user: string;
    message: string;
    time: string;
    isSelf: boolean;
};

export function isUserChatMessage(message: string): boolean {
    try {
        JSON.parse(message);
        return false;
    } catch {
        return !message.includes('"action"') && !message.includes("'action'");
    }
}

export function createChatMessage(
    id: string,
    user: string,
    message: string,
    selfAlias: string
): ChatMessage {
    return {
        id,
        user,
        message,
        time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
        }),
        isSelf: user === selfAlias,
    };
}
